var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagramWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.3332 7.6665H22.3465M8.33317 1.6665H21.6665C25.3484 1.6665 28.3332 4.65127 28.3332 8.33317V21.6665C28.3332 25.3484 25.3484 28.3332 21.6665 28.3332H8.33317C4.65127 28.3332 1.6665 25.3484 1.6665 21.6665V8.33317C1.6665 4.65127 4.65127 1.6665 8.33317 1.6665ZM20.3332 14.1598C20.4977 15.2695 20.3082 16.4028 19.7915 17.3985C19.2749 18.3943 18.4574 19.2017 17.4553 19.7061C16.4533 20.2104 15.3178 20.386 14.2102 20.2077C13.1027 20.0295 12.0795 19.5066 11.2863 18.7134C10.4931 17.9202 9.97015 16.897 9.79193 15.7895C9.61371 14.6819 9.78926 13.5464 10.2936 12.5443C10.798 11.5423 11.6054 10.7248 12.6012 10.2082C13.5969 9.69149 14.7302 9.50196 15.8398 9.6665C16.9717 9.83435 18.0196 10.3618 18.8288 11.1709C19.6379 11.98 20.1653 13.0279 20.3332 14.1598Z",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagramWhite);
export default __webpack_public_path__ + "static/media/instagramWhite.a26ba71d7d7b4d0ef3063a941d8e7c5f.svg";
export { ForwardRef as ReactComponent };